import { CRITERIA_TYPE, CRITERIA_OBJECT_TYPE, QCCriteria, ViewQCCriteria } from 'app/common/services/SmartQC.service';

export enum FormFieldCode {
  CODE = 'code',
  NAME = 'name',
  DESCRIPTION = 'description',
  TYPE = 'type',
  OBJECT_TYPE = 'object_type',
}

export function buildTableColumns() {
  return [
    {
      title: 'Mã',
      key: 'code',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Tên',
      key: 'name',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Mô tả',
      key: 'description',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Loại',
      key: 'display_type',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
    {
      title: 'Đối tượng',
      key: 'display_object_type',
      display: true,
      allowSort: false,
      classes: 'text-center',
    },
  ];
}

export function buildCreateQCCriteriaModel() {
  return {
    [FormFieldCode.CODE]: '',
    [FormFieldCode.NAME]: '',
    [FormFieldCode.DESCRIPTION]: null,
    [FormFieldCode.TYPE]: CRITERIA_TYPE.AUTO,
    [FormFieldCode.OBJECT_TYPE]: CRITERIA_OBJECT_TYPE.AGENT,
  };
}

export function buildEditQCCriteriaModel(qcCriteria: QCCriteria) {
  const model = {
    [FormFieldCode.CODE]: qcCriteria.code,
    [FormFieldCode.NAME]: qcCriteria.name,
    [FormFieldCode.DESCRIPTION]: qcCriteria.description || null,
    [FormFieldCode.TYPE]: qcCriteria.type,
    [FormFieldCode.OBJECT_TYPE]: qcCriteria.object_type,
  };

  return model;
}

export function buildCreateQCCriteriaPayload(model: any) {
  const payload = {
    [FormFieldCode.CODE]: model[FormFieldCode.CODE],
    [FormFieldCode.NAME]: model[FormFieldCode.NAME],
    [FormFieldCode.DESCRIPTION]: model[FormFieldCode.DESCRIPTION],
    [FormFieldCode.TYPE]: model[FormFieldCode.TYPE],
    [FormFieldCode.OBJECT_TYPE]: model[FormFieldCode.OBJECT_TYPE],
  };

  return payload;
}

export function buildEditQCCriteriaPayload(model: any, qcCriteria: QCCriteria) {
  const payload = {};

  if (model[FormFieldCode.CODE] !== qcCriteria.code) {
    payload[FormFieldCode.CODE] = model[FormFieldCode.CODE];
  }

  if (model[FormFieldCode.NAME] !== qcCriteria.name) {
    payload[FormFieldCode.NAME] = model[FormFieldCode.NAME];
  }

  if (model[FormFieldCode.DESCRIPTION] !== qcCriteria.description) {
    payload[FormFieldCode.DESCRIPTION] = model[FormFieldCode.DESCRIPTION];
  }

  if (model[FormFieldCode.TYPE] !== qcCriteria.type) {
    payload[FormFieldCode.DESCRIPTION] = model[FormFieldCode.TYPE];
  }

  if (model[FormFieldCode.OBJECT_TYPE] !== qcCriteria.description) {
    payload[FormFieldCode.DESCRIPTION] = model[FormFieldCode.OBJECT_TYPE];
  }

  return payload;
}

export function buildViewQCCriteria(qcCriteria: QCCriteria): ViewQCCriteria {
  return {
    ...qcCriteria,
    display_type: qcCriteria.type === CRITERIA_TYPE.AUTO ? 'Auto' : 'Manual',
    display_object_type: qcCriteria.object_type === CRITERIA_OBJECT_TYPE.AGENT ? 'Chuyên viên' : 'Khác',
  };
}



// WEBPACK FOOTER //
// ./src/app/pages/admin/icontact/smart-qc/setting/criteria/setting-criteria.util.ts